import React from 'react';
import styles from '../search.module.css';

export default function SearchForm({ searchQuery, handleInputChange, handleSearch }) {
  return (
    <div  className={styles.searchForm}>
      <div className={styles.searchContainer}>
        <input
          type="text"
          placeholder="Search your domain"
          className={styles.searchInput}
          value={searchQuery}
          onChange={handleInputChange}
          aria-label="Search input"
        />
        <button onClick={handleSearch} className={styles.searchButton}>Search</button>
      </div>
    </div>
  );
}
